export default {
    data() {
        return {
            datePickerOptions: {
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                }
            }
        };
    },
};
